import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const storeOrders = (storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-order-by-status',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const storeOrdersWithPagination = (storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v2/store/' +
      storeId +
      '/store-order-by-status',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// v3
export const storeOrdersWithPaginationAndSearch = (storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v3/store/' +
      storeId +
      '/store-order-by-status',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// export const storeOrdersMergeInvoicePdf = (data) => {
//   return axios({
//     method: 'post',
//     url:
//       STORE_BASE_URL +
//       '/store/api/secure/v1/bulk-order-download-invoice/',
//     // for android use
//     headers: getHeaders(),
//     data: JSON.stringify(data),
//   });
// };

export const storeOrdersMergeInvoicePdf = (data, myFileName) => {
  return axios({
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/bulk-order-download-invoice/',
    method: 'POST',
    responseType: 'blob', // crucial for binary data
    data: JSON.stringify(data),
    headers: getHeaders(),
  })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', myFileName + '_merge.pdf');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    })
    .catch(error => {
      console.error('Error downloading PDF:', error);
    });
}

export const storeCustomerInfoOrders = (storeId, storeCustomerId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/order-by-status',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const brandAdminOrders = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store-order-by-status',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const brandAdminOrdersWithPaginationAndSearch = (brandId, data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v2/brand/" +
      brandId +
      "/store-order-by-status",
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// B2BModel

export const B2BChallanWithPaginationAndSearch = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/b2b/search-challan',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const B2BChallanOrder = (storeId, storeCustomerId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/b2b/store/' + storeId + '/store-customer/' + storeCustomerId + '/challan/order',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const OrderEditWithType = (storeId, storeCustomerId, orderId, type) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' + storeId + '/store-customer/' + storeCustomerId + '/order/' + orderId + '/edit-' + type,
    headers: getHeaders(),
  });
};
